import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Apps list chrome — the reference width/padding for Assemble inner pages. */
export const PAGE_CONTAINER_CLASS = 'container mx-auto py-8 px-6';

export const PAGE_TITLE_CLASS = 'text-2xl font-bold';

interface AdminPageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

/**
 * List-page title row: Assemble PageHeader type, no icon, no bordered block.
 * Optional description stays muted under the title when a page still needs it.
 */
export function AdminPageHeader({ title, description, actions, className }: AdminPageHeaderProps) {
  return (
    <div className={cn('mb-6', className)}>
      <div className="flex items-center justify-between gap-4">
        <h1 className={PAGE_TITLE_CLASS}>{title}</h1>
        {actions}
      </div>
      {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
    </div>
  );
}
